import {
  PAYMENT_TYPE_OPTIONS,
  PAYMENT_TYPES_WITH_TRANSACTION_REF,
} from '../constants/marketPromotion.constants';

const ISO_DATE_LENGTH = 10;

export const WHOLE_NUMBER_PATTERN = /^\d+$/;
export const OPTIONAL_WHOLE_NUMBER_PATTERN = /^\d*$/;

export interface NamedOption {
  id: number;
  name: string;
}

export const isPicked = (optionId: number | undefined): boolean => optionId !== undefined;

export function findOptionId(
  options: readonly NamedOption[],
  name: string | null,
): number | undefined {
  return options.find((option) => option.name === name)?.id;
}

export function findOptionName(
  options: readonly NamedOption[],
  id: number | undefined,
): string | undefined {
  return options.find((option) => option.id === id)?.name;
}

export function isTransactionRefNeeded(paymentTypeId: number | undefined): boolean {
  return PAYMENT_TYPES_WITH_TRANSACTION_REF.includes(
    findOptionName(PAYMENT_TYPE_OPTIONS, paymentTypeId) ?? '',
  );
}

export const toOptionalText = (text: string): string | undefined =>
  text.trim() === '' ? undefined : text.trim();

export const toNumberText = (amount: number | null): string =>
  amount === null ? '' : String(amount);

export const toDateFieldText = (date: string | null): string =>
  date?.slice(0, ISO_DATE_LENGTH) ?? '';
